export default "__VITE_ASSET__sb3vQM8I__"